import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { BaseCadouhApiService } from '../../../shared/services/base-cadouh-api.service';
import { LimitOffsetPagination } from '../../../shared/models/limit-offset-pagination';
import { GenericPaginationResponseBody } from '../../../shared/models/Generic-pagination-response-body';
import { Wallet } from '../models/wallet';
import { WalletTransaction } from '../models/wallet-transaction';
import { WalletPayout } from '../models/wallet-payout';

@Injectable({
  providedIn: 'root'
})
export class WalletApiService extends BaseCadouhApiService {

  getWallet(): Observable<Wallet> {
    return this.http.get<Wallet>(
      `${this.baseUrl}/giftshop/admin/vendor_settings/wallet/`,
      { headers: this.getRequestHeadersWithToken() }
    );
  }

  getTransactions(
    pagination: LimitOffsetPagination,
    search: string = '',
    filters: Record<string, string | number> = {}
  ): Observable<GenericPaginationResponseBody<WalletTransaction>> {
    const params = new URLSearchParams({
      limit: String(pagination.limit),
      offset: String(pagination.offset),
      search,
    });
    for (const [k, v] of Object.entries(filters)) {
      if (v !== null && v !== undefined && v !== '') params.set(k, String(v));
    }
    return this.http.get<GenericPaginationResponseBody<WalletTransaction>>(
      `${this.baseUrl}/giftshop/admin/vendor_settings/wallet/transactions/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken() }
    );
  }

  getPayouts(
    pagination: LimitOffsetPagination,
    search: string = '',
    filters: Record<string, string | number> = {}
  ): Observable<GenericPaginationResponseBody<WalletPayout>> {
    const params = new URLSearchParams({
      limit: String(pagination.limit),
      offset: String(pagination.offset),
      search,
    });
    for (const [k, v] of Object.entries(filters)) {
      if (v !== null && v !== undefined && v !== '') params.set(k, String(v));
    }
    return this.http.get<GenericPaginationResponseBody<WalletPayout>>(
      `${this.baseUrl}/giftshop/admin/vendor_settings/wallet/payouts/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken() }
    );
  }

  exportTransactions(
    search: string = '',
    filters: Record<string, string | number> = {}
  ): Observable<Blob> {
    const params = new URLSearchParams({ search });
    for (const [k, v] of Object.entries(filters)) {
      if (v !== null && v !== undefined && v !== '') params.set(k, String(v));
    }
    return this.http.get(
      `${this.baseUrl}/giftshop/admin/vendor_settings/wallet/transactions/export/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken(), responseType: 'blob' },
    );
  }

  exportPayouts(
    search: string = '',
    filters: Record<string, string | number> = {}
  ): Observable<Blob> {
    const params = new URLSearchParams({ search });
    for (const [k, v] of Object.entries(filters)) {
      if (v !== null && v !== undefined && v !== '') params.set(k, String(v));
    }
    return this.http.get(
      `${this.baseUrl}/giftshop/admin/vendor_settings/wallet/payouts/export/?${params.toString()}`,
      { headers: this.getRequestHeadersWithToken(), responseType: 'blob' },
    );
  }
}
